import { Alert, Button, IconButton } from '@mui/material';
import styles from './AddArtefacto.module.css'
import AddIcon from '@mui/icons-material/Add';
import ModalCenter from '../../../components/modal/modalCenter'
import { useContext, useEffect, useState } from 'react';
import Input from '../../../components/input/input'
import ApiFetch from '../../../utils/fetch';
import SwalAlert from '../../../utils/swalAlert';
import Loading from '../../../components/loading/loading';
import { AppContext } from '../../../context/context';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Swal from 'sweetalert2';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const fetch = new ApiFetch()
const alert = new SwalAlert()

const AddArtefacto = ({getMyList}) => {
    const {sessionExpired} = useContext(AppContext)
    const [loading, setLoading] = useState('')
    const [show, setShow] = useState(false);
    const [listArtefactos, setListArtefactos] = useState([])
    const [idTipoArtefacto, setIdTipoArtefacto] = useState('')
    const [marca, setMarca] = useState('')
    const [modelo, setModelo] = useState('')
    const [nroSerie, setNroSerie] = useState('')
    const [artefactos, setArtefactos] = useState([])
    const [addAlert, setAddAlert] = useState('')
    const [dsArtefacto, setDsArtefacto] = useState('')

        const getListArtefactos = async () => {
        try {
            setLoading(<Loading/>)
            const data = await fetch.GET('/artefactos/lista');
            setLoading('')
            const status = data?.status
            const message = data?.message
            switch (status) {
                case 200:
                    setListArtefactos(data?.body)
                    break;
                case 401:
                    sessionExpired(message)
                    break;
                default:
                    alert.error(message)
                    break;
            }
        } catch (error) {
            setLoading('')
        }
    }


    const addToListArtefacto = () => {
        setAddAlert('')
            if (!idTipoArtefacto || !marca || !modelo || !nroSerie) {
            return;
        }
        setLoading(<Loading/>)
        setTimeout(() => {
        setArtefactos([...artefactos, { idTipoArtefacto, dsArtefacto, marca, modelo, nroSerie }]);
        setIdTipoArtefacto('')
        setMarca('')
        setModelo('')
        setNroSerie('')
        setAddAlert(<Alert severity='success'>Artefacto añadido correctamente.</Alert>)
        setLoading('')
        }, 500);
    }

    useEffect(()=>{
        getListArtefactos()
    },[])

    const declarar = async () => {
        try {
            if (!artefactos.length > 0) {
                return;
            }
            setLoading(<Loading/>)
            const body = JSON.stringify({artefactos})
            const data = await fetch.POST(body, '/artefactos/declarar');
            setLoading('')
            const status = data?.status
            const message = data?.message
            switch (status) {
                case 201:
                    setArtefactos([])
                    await getMyList()
                    alert.success(message)
                    break;
                case 401:
                    setArtefactos([])
                    sessionExpired(message)
                    break;
                default:
                    setArtefactos([])
                    alert.error(message)
                    break;
            }
          
        } catch (error) {
            setLoading('')
            alert.error('No fue posible declarar los artefactos, por favor intente nuevamente más tarde.')
        }
    }


      const handleChange = (event) => {
    setIdTipoArtefacto(event.target.value);
    };

    useEffect(() => {
        setAddAlert('')
        setIdTipoArtefacto('')
        setMarca('')
        setModelo('')
        setNroSerie('')
    },[show])
    

    const confirmDeleteArtefacto = (idArtefacto) => {
        Swal.fire({
  text: "¿Desea eliminar el artefacto?",
  icon: "question",
  showCancelButton: true,
  confirmButtonColor: "#d33",
  cancelButtonColor: "grey",
  confirmButtonText: "Eliminar",
  cancelButtonText:'Cancelar'
}).then(async (result) => {
  if (result.isConfirmed) {
    await deleteArtefacto(idArtefacto)
  }
});
    }

    const deleteArtefacto = async (idArtefacto) => {
        const artefactosFilter = artefactos.filter(artefacto => artefacto.idTipoArtefacto !== idArtefacto)
       setArtefactos(artefactosFilter)
    }


    return (
        <div className={styles.container}>
                <div className={styles.form}>
                     <Box sx={{ minWidth: 120 }}>
      <FormControl fullWidth>
        <InputLabel id="demo-simple-select-label">Seleccione el artefacto</InputLabel>
        <Select
        size='small'
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={idTipoArtefacto}
          onChange={handleChange}
          label='Seleccione el artefacto'
        >
            {listArtefactos?.length > 0 && listArtefactos?.map((item,i) => (<MenuItem onClick={()=>setDsArtefacto(item?.Dsartefacto)} key={i} value={item.Idtipoartefacto}>{item?.Dsartefacto}</MenuItem>))}
        </Select>
      </FormControl>
    </Box>
                <div className={styles.inputsContainer}>
                <Input label='Marca' value={marca} setValue={setMarca} maxLength={150} size='small' />
                <Input label='Modelo' value={modelo} setValue={setModelo} maxLength={150} size='small' />
                <Input label='Nro. de Serie' value={nroSerie} setValue={setNroSerie} maxLength={150} size='small' />
                </div>
                </div>
                {addAlert}
                <div className={styles.btnContainer}><Button onClick={()=>setShow(true)} variant='text' color='info' size='small'>ver añadidos({artefactos?.length})</Button><Button size='small' color='primary' variant='contained' onClick={() => addToListArtefacto()}>Añadir</Button></div>
               
                <div className={styles.declararBtnContainer}>
                <Button size='small' variant='contained' color='success' onClick={()=>declarar()}>Finalizar y declarar</Button>
                </div>
                {loading}
                <ModalCenter title={`Artefactos para declarar (${artefactos?.length})`} show={show} setShow={setShow}>
                <div className={styles.tableContainer}>
                {artefactos?.length > 0 ? (
                    <table className={styles.tableServices}>
                        <thead>
                            <tr>
                                <th>Artefacto</th>
                                <th>Marca</th>
                                <th>Modelo</th>
                                <th>Nro. de serie</th>
                                <th></th>
                            </tr>
                        </thead>
                        {artefactos?.map((artefacto, i) => {
                            return (
                                <tbody key={i} style={{ fontSize: 12, wordWrap: 'break-word' }}>
                                    <tr>
                                        <td>{artefacto?.dsArtefacto}</td>
                                        <td>{artefacto?.marca}</td>
                                        <td>{artefacto?.modelo}</td>
                                         <td>{artefacto?.nroSerie}</td>
                                        <td><IconButton onClick={()=>confirmDeleteArtefacto(artefacto.idTipoArtefacto)} color='error'><DeleteForeverIcon/></IconButton></td>
                                    </tr>
                                </tbody>
                            );
                        })}
                    </table>
                ) : (
                    <p>Aún no hay artefactos para declarar.</p>
                )}
            </div>
                </ModalCenter>

                </div>
    )
}

export default AddArtefacto;